import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import { auth } from "../../Authentication/firebase/firebase";
import API_Root from "../../Constants/API_Root";
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import {authFetch} from "../../Authentication/authService";

// NEW dependency for date-range picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SIDEBAR_WIDTH = 250;

function ActivityLog() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userEmail, setUserEmail] = useState("");

  // NEW: store processed products here
  const [productsData, setProductsData] = useState([]);
  // NEW: activity rows data
  const [activityRows, setActivityRows] = useState([]);

  const history = useHistory();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);
        fetchActivityInformation(userEmail);
      } else {
        setUserEmail("");
      }
    });

    return () => unsubscribe();
  }, []);

  // 👉 PROCESS API RESPONSE HERE
const fetchActivityInformation = (username) => {
  authFetch(API_Root + "users/fetch-activity-logs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username }),
  })
    .then((response) => response.json())
    .then((data) => {

      // API returns array directly
      if (Array.isArray(data)) {
        setActivityRows(
          data.map((a) => ({
            timestamp: a.activity_timestamp || "Unknown",
            activity: a.activity || "-",
            description: a.description || "-",
            product: a.product || "-",
          }))
        );

        // derive products list
        const derived = [...new Set(data.map((a) => a.product))];
        setProductsData(derived);

        return;
      }

      // fallback if wrong format
      setActivityRows([]);
      setProductsData([]);
    })
    .catch((error) => {
      console.error("Error:", error);

      // fallback UI data
      setActivityRows([]);
      setProductsData([]);
    });
};

const handleLogout = () => {
  doSignOut()
    .then(() => {
      localStorage.removeItem("isLoggedIn");
      history.push("/");
    })
    .catch(() => {
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Logout failed",
        })
      );
    });
};


useEffect(() => {
  const resize = () => setIsDesktop(window.innerWidth >= 768);
  window.addEventListener("resize", resize);
  return () => window.removeEventListener("resize", resize);
}, []);

  const containerStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const contentStyle = {
    // marginLeft: isDesktop ? SIDEBAR_WIDTH : 0,
    width: "100%",
    transition: "margin-left 0.3s ease",
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });
  const ProductPage = () => history.push("/myproduct");
  const AccountPage = () => history.push("/profile");
  const ShopPage = () => history.push("/shops");
  const SuportPage = () => history.push("/support");
  const TrainingPage = () => {
    history.push("/training");
  };

  //
  // ===== NEW UI/STATE FOR FILTERS & DATE PICKER (inserted into your comment area)
  //
  const [dateRangeOpen, setDateRangeOpen] = useState(false);
  const datePickerRef = useRef(null);
  const [dateRange, setDateRange] = useState([null, null]); // [start, end]
  const [startDate, endDate] = dateRange;

  const [productFilter, setProductFilter] = useState("All");
  const [activityFilter, setActivityFilter] = useState("All");

  // Clicking outside date popover closes it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
        setDateRangeOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // derived displayed rows after filters
  const displayedRows = activityRows.filter((r) => {
    if (productFilter !== "All" && r.product !== productFilter) return false;
    if (activityFilter !== "All") {
      // basic case-insensitive includes check
      if (!r.activity.toLowerCase().includes(activityFilter.toLowerCase())) return false;
    }
    if (startDate && endDate) {
      // try parse a date from r.timestamp (assumes format like 'Oct 13, 2025')
      const parsed = Date.parse(r.timestamp);
      // if parse fails, include row
      if (!isNaN(parsed)) {
        const t = new Date(parsed);
        // compare only date portion
        const tNoTime = new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
        const s = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()).getTime();
        const e = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()).getTime();
        if (tNoTime < s || tNoTime > e) return false;
      }
    }
    return true;
  });

  // format label for range button
  const rangeLabel = startDate && endDate
    ? `${startDate.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric" })} – ${endDate.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}`
    : "28 Oct 25 – 10 Nov 25";

  return (
    <div className="container-fluid p-0">
    <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

      <div className="d-flex">
        {/* SIDEBAR */}
        <div style={sidebarStyle}>
          <h5 className="fw-bold mb-4 d-flex justify-content-between align-items-center">
            E&S Solutions
            {!isDesktop && (
              <i
                className="bi bi-x-lg"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(false)}
              />
            )}
          </h5>

          <div style={getHoverStyle("My Products")} onClick={ProductPage}>
            My Products
          </div>

          <div style={getHoverStyle("Shop")} onClick={ShopPage}>
            Shop / Marketplace
          </div>

          <div style={getHoverStyle("Training")} onClick={TrainingPage}>
            E&S Solutions Training Centre
          </div>

          <div style={getHoverStyle("Support")} onClick={SuportPage}>
            Support & Help
          </div>

          <div style={getHoverStyle("Account")} onClick={AccountPage}>
            Account Settings
          </div>

          <div style={activeNavItemStyle}>Activity Log</div>
        </div>

        {/* Main Content */}
        <div style={contentStyle}>
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            {!isDesktop && (
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              ></i>
            )}
            <h4 className="fw-bold m-0">Activity Logs</h4>
            <div>
            <button
            className="me-2"
            onClick={handleLogout}
            style={{
              border: "1px solid black",
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: '5px',
              transition: "all 0.3s ease",
              fontSize: "small",
            }}
          >
            Logout
          </button>
              <i className="bi bi-bell me-3"></i>
              <img
                src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
                alt="Profile"
                width={"20px"}
                className="rounded-circle"
              />
            </div>
          </div>

          <div className="p-4" style={{ maxWidth: "100%", overflowX: "hidden" }}>
            <div style={containerStyle}>
              {/* here is the comment -  */}
              {/* ===== Added UI START ===== */}
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h5 className="fw-bold mb-1">Activity Log</h5>
                  <div className="text-secondary">Track your recent actions across E&S Solutions.</div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  {/* Date range dropdown */}
                  <div className="position-relative" ref={datePickerRef}>
                    <button
                      type="button"
                      className="btn btn-outline-secondary d-flex align-items-center"
                      style={{ borderRadius: "8px", padding: "10px 14px", minWidth: 180 }}
                      onClick={() => setDateRangeOpen((s) => !s)}
                    >
                      <span className="me-2" style={{ fontSize: 14 }}>{rangeLabel}</span>
                      <i className="bi bi-caret-down-fill"></i>
                    </button>

                    {dateRangeOpen && (
                      <div
                        className="position-absolute bg-white border rounded shadow-sm p-2"
                        style={{ right: 0, zIndex: 2000, marginTop: 8 }}
                      >
                        <DatePicker
                          selectsRange
                          startDate={startDate}
                          endDate={endDate}
                          onChange={(update) => {
                            setDateRange(update);
                          }}
                          inline
                        />
                        <div className="d-flex justify-content-between mt-2">
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => {
                              setDateRange([null, null]);
                            }}
                          >
                            Clear
                          </button>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => setDateRangeOpen(false)}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Product dropdown */}
                  <div>
                    <select
                      className="form-select"
                      style={{ minWidth: 150, borderRadius: 8 }}
                      value={productFilter}
                      onChange={(e) => setProductFilter(e.target.value)}
                    >
                      <option value="All">Product</option>
                      {/* include derived products */}
                      {productsData && productsData.length > 0
                        ? productsData.map((p, i) => (
                            <option value={p} key={i}>
                              {p}
                            </option>
                          ))
                        : (
                          <>
                            <option>Training Centre</option>
                            <option>My Products</option>
                            <option>Billing</option>
                          </>
                        )}
                    </select>
                  </div>

                  {/* Activity type dropdown */}
                  <div>
                    <select
                      className="form-select"
                      style={{ minWidth: 150, borderRadius: 8 }}
                      value={activityFilter}
                      onChange={(e) => setActivityFilter(e.target.value)}
                    >
                      <option value="All">Activity Type</option>
                      <option>Completed module</option>
                      <option>Added new user</option>
                      <option>Subscription renewed</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Table container styled to match screenshot */}
              <div className="table-responsive">
                <div
                  className="border"
                  style={{
                    borderRadius: 12,
                    overflow: "hidden",
                    borderColor: "#e6e6e6",
                  }}
                >
                  <table className="table mb-0">
                    <thead style={{ background: "#fafafa" }}>
                      <tr>
                        <th style={{ padding: "22px 20px", width: "20%" }}>Timestamp</th>
                        <th style={{ padding: "22px 20px", width: "25%" }}>Activity</th>
                        <th style={{ padding: "22px 20px", width: "45%" }}>Description</th>
                        <th style={{ padding: "22px 20px", width: "10%" }}>Product</th>
                      </tr>
                    </thead>

                    <tbody>
                      {displayedRows.length === 0 ? (
                        <tr>
                          <td colSpan={4} className="text-center py-5 text-secondary">
                            No activity found for selected filters.
                          </td>
                        </tr>
                      ) : (
                        displayedRows.map((row, idx) => (
                          <tr key={idx} style={{ borderTop: "1px solid #eee" }}>
                            <td style={{ padding: "20px" }} className="fw-semibold">
                            {new Date(row.timestamp).toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
})}
                            </td>
                            <td style={{ padding: "20px" }}>{row.activity}</td>
                            <td style={{ padding: "20px" }}>{row.description}</td>
                            <td style={{ padding: "20px" }} className="fw-semibold">
                              {row.product}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* ===== Added UI END ===== */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivityLog;
